import styled from 'styled-components';
import { Button } from 'components';
export const ConfirmDeleteContentStyled = styled.p`
  margin-bottom: 31px;
  color: var(--black);
  font-size: 14px;
  letter-spacing: 0;
  line-height: 21px;
  padding-left: 24px;
`;
export const ButtonCut = styled(Button)`
  background: linear-gradient(149.45deg, #3c82c0 0%, #1c4b8c 100%);
  color: var(--white) !important;
  &:disabled {
    background-color: #f5f5f5;
  }
  &:hover {
    background: linear-gradient(149.45deg, #3c82c0 0%, #1c4b8c 100%);
  }
`;
export const HeaderStyled = styled.div`
  display: flex;
  cursor: pointer;
  flex-direction: row;
  font-size: 18px;
  letter-spacing: 0;
  line-height: 27px;
  img {
    cursor: pointer;
    margin-right: 16px;
  }
`;

export const DetailImageContentStyled = styled.section`
  display: flex;
  padding-left: 24px;
  padding-right: 24px;
  padding-bottom: 24px;
  .card-width-height {
    position: relative;
    background-color: #fff;
    margin: 0 auto;
  }
  .image {
    width: 600px;
    max-height: 450px;
  }
  .image-graft {
    height: 450px;
  }
  .image-crop {
    height: 450px;
    max-width: 100%;
    max-height: 100%;
  }
  .ReactCrop__image {
    width: 600px;
    height: 450px;
  }
  .title {
    font-size: 14px;
    letter-spacing: 0;
    line-height: 21px;
    margin-bottom: 16px;
  }
  .info {
    margin-left: 24px;
    font-weight: 500;
    width: 300px;
    .title {
      font-weight: 700;
    }
    .info-item {
      font-size: 14px;
      letter-spacing: 0;
      line-height: 16px;
      margin-bottom: 16px;
      white-space: pre-wrap;
    }
  }
  .album-image {
    max-height: 315px;
    overflow-y: auto;
    width: 426px;
  }
`;
export const DetailImageContentStyledGraft = styled.section`
  display: flex;
  padding-left: 24px;
  padding-right: 24px;
  .card-width-height {
    position: relative;
    background-color: #fff;
    margin: 0 auto;
  }
  .image {
    width: 600px;
    max-width: 100%;
    max-height: 450px;
  }
  .image-graft {
    height: 450px;
  }
  .image-crop {
    height: 450px;
    max-width: 100%;
    max-height: 100%;
  }
  .ReactCrop__image {
    width: 600px;
    height: 450px;
  }
  .title {
    font-size: 14px;
    letter-spacing: 0;
    line-height: 21px;
    margin-bottom: 16px;
  }
  .info {
    margin-left: 24px;
    font-weight: 500;
    width: 408px;
    .title {
      font-weight: 700;
    }
    .info-item {
      font-size: 14px;
      letter-spacing: 0;
      line-height: 16px;
      margin-bottom: 16px;
    }
  }
  .album-image {
    max-height: 315px;
    overflow-y: auto;
    width: 426px;
  }
`;

export const ConfirmUploadContentStyled = styled.div`
  padding: 0 24px 0 24px;
`;

export const ButtonSubmit = styled.div`
  .button-submit {
    background: linear-gradient(149.45deg, #3c82c0 0%, #1c4b8c 100%);
    color: var(--white) !important;
  }
  .button-submit:hover {
    background: linear-gradient(149.45deg, #3c82c0 0%, #1c4b8c 100%);
    color: var(--white) !important;
  }
`;

export const CardGraft = styled.div`
  cursor: move;
  width: 210px !important;
  .ant-card-body {
    padding: 8px !important;
  }
  .title-name {
    border: 1px solid #bdbdbd;
    width: 194px;
    margin: auto;
    height: 40px;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .title-id-about {
    border-left: 1px solid #bdbdbd;
    border-right: 1px solid #bdbdbd;
    border-bottom: 1px solid #bdbdbd;
    width: 100%;
    margin: auto;
    height: 25px;
    font-size: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .title-id-image {
    width: 194px;
    height: 145px;
    margin: auto;
    -webkit-user-drag: none;
  }
  .ant-skeleton-title {
    height: auto;
  }
  .ant-skeleton-content {
    border-right: 1px solid #bdbdbd;
    border-bottom: 1px solid #bdbdbd;
    border-left: 1px solid #bdbdbd;
  }
  .title-id-image-empty {
    height: 145px;
    border-left: 1px solid #bdbdbd;
    border-right: 1px solid #bdbdbd;
    border-bottom: 1px solid #bdbdbd;
    margin: auto;
    font-size: 10px;
    .ant-empty-img-simple {
      margin-top: 24px;
      padding: 4px;
    }
    .ant-empty-description {
      margin-top: 24px;
      position: absolute;
      left: 0;
      right: 0;
      top: 55%;
    }
  }
`;
